document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const drawer=document.querySelector('[data-mobile-drawer]');
  const open=document.querySelector('[data-mobile-open]');
  const close=document.querySelector('[data-mobile-close]');
  const set=(on)=>{ if(!drawer)return; drawer.classList.toggle('is-open',on); document.body.style.overflow=on?'hidden':''; };
  if(open)open.addEventListener('click',()=>set(true));
  if(close)close.addEventListener('click',()=>set(false));
  document.querySelectorAll('[data-mobile-drawer] a').forEach(a=>a.addEventListener('click',()=>set(false)));
});
